export default "__VITE_PUBLIC_ASSET__101a6a21__"